"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatedNeededServerSideWrapperComponents = exports.generatedNeededClientSideWrapperComponents = exports.enhanceHypernovaRendererData = exports.generateHistoryObject = exports.getAemConfigurationFromBrowserContext = void 0;
const common_utils_1 = require("@as-react/common-utils");
const history_1 = require("history");
const wrappers_1 = require("../wrappers");
const propsInserter_1 = require("../wrappers/propsInserter");
const generatedNeededWrapperComponents = (hypernovaRenderData, store) => {
    const possibleWrappers = [];
    possibleWrappers.push({
        wrapper: propsInserter_1.propInserter,
        additionalWrapperArguments: {
            ssrProps: hypernovaRenderData.props,
        },
    });
    possibleWrappers.push({
        wrapper: wrappers_1.wrapWithAemConfigurationContext,
        additionalWrapperArguments: {
            aemConfigurationValue: hypernovaRenderData.context.aemConfiguration,
        },
    });
    possibleWrappers.push({
        wrapper: wrappers_1.wrapWithABContext,
        additionalWrapperArguments: {
            abConfigurationValue: hypernovaRenderData.context.abConfiguration,
        },
    });
    possibleWrappers.push({
        wrapper: wrappers_1.wrapWithQueryContext,
        additionalWrapperArguments: {
            dehydratedState: hypernovaRenderData.queryClientState,
        },
    });
    if (store) {
        possibleWrappers.push({
            wrapper: wrappers_1.wrapWithReduxStoreContainer,
            additionalWrapperArguments: { store },
        });
    }
    return possibleWrappers;
};
const getAemConfigurationFromBrowserContext = () => (0, common_utils_1.getCustomWindowObject)('SITE.Config');
exports.getAemConfigurationFromBrowserContext = getAemConfigurationFromBrowserContext;
const generateHistoryObject = () => {
    const history = typeof window === 'undefined' ? (0, history_1.createMemoryHistory)() : (0, history_1.createBrowserHistory)();
    return history;
};
exports.generateHistoryObject = generateHistoryObject;
const enhanceHypernovaRendererData = (hypernovaRenderData, i18nTranslationResources) => {
    let enhancedTranslationResources = {};
    const hypernovaDataContainsTranslations = !!hypernovaRenderData.loadByClient &&
        !!hypernovaRenderData.loadByClient.find(s => s === wrappers_1.HYPERNOVA_TRANSPORTABLE.TRANSLATION);
    if (hypernovaDataContainsTranslations && !!i18nTranslationResources) {
        enhancedTranslationResources = {
            translation: {
                translationResources: i18nTranslationResources.translationResources,
            },
        };
    }
    let enhancedAemConfiguration = {};
    if (!!hypernovaRenderData.loadByClient &&
        !!hypernovaRenderData.loadByClient.find(s => s === wrappers_1.HYPERNOVA_TRANSPORTABLE.OBJECT_CONTEXT_AEM_CONFIGURATION)) {
        enhancedAemConfiguration = {
            context: {
                aemConfiguration: (0, exports.getAemConfigurationFromBrowserContext)(),
            },
        };
    }
    return Object.assign(Object.assign(Object.assign({}, hypernovaRenderData), enhancedTranslationResources), enhancedAemConfiguration);
};
exports.enhanceHypernovaRendererData = enhanceHypernovaRendererData;
const generatedNeededClientSideWrapperComponents = (hypernovaRenderData, history, store) => {
    const possibleWrappers = [];
    if (!!store && !!history) {
        possibleWrappers.push({
            wrapper: wrappers_1.wrapWithRouterReduxContainer,
            additionalWrapperArguments: { history },
        });
    }
    generatedNeededWrapperComponents(hypernovaRenderData, store).forEach(item => possibleWrappers.push(item));
    return possibleWrappers;
};
exports.generatedNeededClientSideWrapperComponents = generatedNeededClientSideWrapperComponents;
const generatedNeededServerSideWrapperComponents = (hypernovaRenderData, store) => {
    const possibleWrappers = generatedNeededWrapperComponents(hypernovaRenderData, store);
    possibleWrappers.push({
        wrapper: wrappers_1.wrapWithTranslationContainer,
        additionalWrapperArguments: {
            initialData: hypernovaRenderData.translation,
        },
    });
    return possibleWrappers;
};
exports.generatedNeededServerSideWrapperComponents = generatedNeededServerSideWrapperComponents;
//# sourceMappingURL=utils.js.map